import api from '@/common/api';
import { IUser, UserRole } from '@/types/app';
import { useDebouncedSearch } from '@/utils/hooks';
import { AutoComplete } from 'antd';
import { useEffect } from 'react';

interface IProps {
  user?: IUser;
  onSelect: (id: string, record: IUser) => void;
  placeholder?: string;
  showSuggest?: boolean;
  disabled?: boolean;
  roles?: UserRole[];
}

const SearchUsers = ({ user, onSelect, showSuggest, placeholder = 'Search users', disabled, roles }: IProps) => {
  const { searchResults, setInputText } = useDebouncedSearch((text) =>
    api.getSharedUsers({
      keyword: text,
      limit: 10,
      ...(roles ? { roles } : null),
    }),
  );

  const _onSelect = (item: any, option: any) => {
    const record = searchResults?.result?.data?.data?.find((item: IUser) => item.id === option?.key);
    onSelect?.(option?.key, record);
  };

  useEffect(() => {
    if (showSuggest) {
      setInputText('');
    }
  }, []);

  const renderOptions = () => {
    return searchResults?.result?.data?.data?.map((item: IUser) => ({
      value: item.name || item?.username,
      label: <span>{item.name || item?.username}</span>,
      key: item?.id,
    }));
  };
  return (
    <AutoComplete
      placeholder={placeholder}
      options={renderOptions()}
      defaultValue={user?.email}
      onSelect={_onSelect}
      onSearch={setInputText}
      disabled={disabled}
    />
  );
};

export default SearchUsers;
